export enum PosthogGuaranteeVariant {
  Control = 'control',
  Variant = 'variant',
  Cro = 'cro',
}
